const ENV = "PROD";

const configs = {
  LOCAL: {
    apiBaseUrl: "http://localhost:3002"
  },
  PROD: {
    apiBaseUrl: "https://api.lexoraholdings.com"
  }
};

const config = () => configs[ENV];

const configModule = { config };

export default configModule;

